export const termsOfUse = [

  {
    id: 1,
    title: "1. Acceptance of Terms",

    content: `
Welcome to Magyne ERP.

These Terms of Use govern your access to and use of Magyne
software solutions, websites, applications and related services.

By creating an account, accessing our platform, or using any
Magyne service, you acknowledge that you have read, understood
and agree to be bound by these Terms of Use.

If you do not agree with these terms, you must not use our services.
`
  },


  {
    id: 2,
    title: "2. Description of Services",

    content: `
Magyne provides cloud-based business management software solutions
designed to help organizations manage their operations.

Our solutions may include:

• Business management systems.

• Educational administration platforms.

• Customer management tools.

• Reporting and analytics.

• Payment and billing features.

Magyne reserves the right to modify, enhance, suspend or discontinue
any feature or service where necessary.
`
  },


  {
    id: 3,
    title: "3. Account Registration",

    content: `
To access Magyne services, you must create an account and provide
accurate and complete information.

You are responsible for:

• Maintaining the confidentiality of your login credentials.

• Ensuring account information remains accurate.

• Restricting unauthorized access to your account.

• Immediately notifying Magyne of suspected security breaches.

You are responsible for all activities performed through your account.
`
  },


  {
    id: 4,
    title: "4. Business and Tenant Accounts",

    content: `
Magyne operates using a secure multi-tenant architecture where each
organization operates within its own isolated environment.

Each registered business is responsible for:

• The accuracy of submitted business information.

• Managing authorized users.

• Ensuring users comply with these Terms.

• Protecting confidential business information.

Customers must not attempt to access another organization's data
or infrastructure.
`
  },


  {
    id: 5,
    title: "5. Acceptable Use",

    content: `
You agree not to use Magyne services to:

• Violate applicable laws or regulations.

• Attempt unauthorized access.

• Introduce malware or harmful code.

• Reverse engineer or copy the platform.

• Abuse system resources.

• Store illegal or harmful content.

Magyne reserves the right to restrict accounts involved in prohibited
activities.
`
  },


  {
    id: 6,
    title: "6. Subscription and Payments",

    content: `
Some Magyne services require a paid subscription.

Customers agree to:

• Pay applicable subscription fees.

• Provide accurate billing information.

• Renew subscriptions according to the selected plan.

Failure to make payments may result in restricted or suspended access.

Pricing and subscription plans may change with prior notice.
`
  },


  {
    id: 7,
    title: "7. Customer Data Ownership",

    content: `
Customers retain ownership of the information and data they store
within Magyne services.

Magyne does not claim ownership of customer data.

Customers grant Magyne permission to process information only for
the purpose of providing, securing and improving the services.

Customers are responsible for ensuring they have appropriate rights
to store and process their information.
`
  },


  {
    id: 8,
    title: "8. Intellectual Property",

    content: `
All Magyne software, designs, trademarks, logos, documentation and
technology remain the intellectual property of Revx Management Systems trading as Magyne ERP.

Customers receive a limited, non-exclusive, non-transferable license
to use the platform during their active subscription period.

No ownership rights are transferred.
`
  },


  {
    id: 9,
    title: "9. Service Availability",

    content: `
Magyne aims to provide reliable and secure services up 99.9% of the time.

However, availability may be affected by:

• Scheduled maintenance.

• Third-party service providers.

• Internet connectivity issues.

• Events beyond reasonable control.

We continuously work to improve reliability and performance.
`
  },


  {
    id: 10,
    title: "10. Limitation of Liability",

    content: `
To the maximum extent permitted by law, Magyne shall not be liable
for indirect, incidental, special or consequential damages resulting
from the use or inability to use our services.

Customers remain responsible for maintaining appropriate backups
and business continuity procedures.
`
  },


  {
    id: 11,
    title: "11. Termination",
    content: `
      Either party may terminate service according to applicable agreements.
      Magyne may suspend or terminate accounts where:
      • These Terms are violated.
      • Fraudulent activity is detected.
      • Security risks are identified.
      • Due subscriptions are not paid.

      Upon termination, access to services may be disabled.
    `
  },


  {
    id: 12,
    title: "12. Changes to These Terms",

    content: `
Magyne may update these Terms of Use from time to time.

Changes will be communicated through appropriate channels.

Continued use of Magyne services after updates means you accept
the revised Terms.
`
  },


  {
    id: 13,
    title: "13. Contact Information",

    content: `
If you have questions regarding these Terms of Use, please contact
Magyne ERP through our official support channels on our contact page.

We are committed to maintaining transparent and fair relationships
with our customers.
`
  }

];